/**
 * 本文件主要用作pc和h5的代码差异桥接
 * 这个文件的意义是为了让armsRum/index.js文件在pc端和h5端保持一致，因为不然每次pc端改了东西，h5想要同步的时候，每次得看逻辑，因为两个端的方法来源以及部分逻辑有细微差距，如果哪次漏写了逻辑就会导致两边不一样，这很不友好。为了解决这个问题，我新增了armsRum/main.js文件来桥接h5和pc两端不一样的差异。让armsRum/index.js在两个端总是保持这样，这就可以一段改完逻辑后，无脑复制覆盖armsRum/index.js
 * 注意： 是无脑复制armsRum/index.js。不是无脑复制armsRum/main.js
 */
import { isProdFn as isProdFn1 } from '@/m-common/lib/collectPoint/index.js'
export const isProdFn = isProdFn1
// 获取当前运行的环境
export const getEnvFn = () => {
  const envList = [
    'localhost',
    '.dev.',
    '.test.',
    '.sit.',
    '.dev2.',
    '.demo.',
    '.gray.',
    '.nk.',
    '.bk.',
    '.uat.',
    '.uat2.'
  ]
  const hostName = window.location.hostname // 域名
  let env = 'eprod' // 默认是生产环境
  for (let i = 0; i < envList.length; i++) {
    if (hostName.indexOf(envList[i]) != -1) {
      env = envList[i].replaceAll('.', '')
      break
    }
  }
  return env
}

// 设置默认的路由模式
export const defauleSpaMode = 'hash'
// 默认的系统名称。 h5端没有默认的title
export const defaultSystemName = ''



// WEBPACK FOOTER //
// ./src/m-common/lib/armsRum/main.js